import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/finance/incoming-invoice/";

export function cancelIncomingInvoice(invoiceID = 0) {
  return http.delete(apiEndpoint + "incoming-invoice/" + invoiceID);
}

export function saveIncomingInvoice(incomingInvoice) {
  return http.post(apiEndpoint, incomingInvoice);
}

export function getIncomingInvoice() {
  return http.get(apiEndpoint);
}

export function getIncomingInvoiceDetail(invoiceID = 0, passAuth = "false") {
  return http.get(apiEndpoint + "invoice-detail/" + invoiceID + "/" + passAuth);
}

export function getRecIncomingInvoiceDetail(invoiceID) {
  return http.get(apiEndpoint + "rec-invoice-detail/" + invoiceID);
}

export function getIncomingInvoicesDocRef() {
  return http.get(apiEndpoint + "incoming-invoice-doc-ref");
}

export function getIncomingInvoicesFromPoItem(poItemID = 0) {
  return http.get(apiEndpoint + "incoming-invoice-po-item/" + poItemID);
}

export function getIncomingInvoiceByPurchaseOrder(poID = 0, contractID = 0) {
  return http.get(apiEndpoint + "po-invoices/" + poID + "/" + contractID);
}
